import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'redux/reducers/rootReducer';
import { TourStepEnum } from 'features/onboarding/enums';

const isWelcomeTourRunningSelector = (state: RootState) =>
  state.onboarding.isWelcomeTourRunning;

const completedTourStepsSelector = (state: RootState) =>
  state.onboarding.completedTourSteps;

const activeTourStepSelector = (state: RootState) =>
  state.onboarding.activeTourStep;

const isTourStepActiveSelector = (tourStep: TourStepEnum) =>
  createSelector<RootState, TourStepEnum | undefined, boolean>(
    activeTourStepSelector,
    (activeStep) => activeStep === tourStep,
  );

const isTourStepCompletedSelector = (tourStep: TourStepEnum) =>
  createSelector<RootState, Array<TourStepEnum>, boolean>(
    completedTourStepsSelector,
    (tourSteps) => tourSteps.includes(tourStep),
  );

export {
  activeTourStepSelector,
  isTourStepActiveSelector,
  completedTourStepsSelector,
  isTourStepCompletedSelector,
  isWelcomeTourRunningSelector,
};
